import { APP_PREFIX_PATH } from "../AppConfig";
import React from "react";

export const avisConfigs = [
    {
        key: "avis-config",
        path: `${APP_PREFIX_PATH}/avis-config`,
        component: React.lazy(() => import("views/app-views/avis-config/index")),
        meta: { permission: "LIST_AVIS_CONFIG" }
    }
];